<template>
    <div id="app" :style="{backgroundColor:custombgcolor?custombgcolor:'transparent'}">
       <!--  <NoticeBar @click="editInfo" mode="link" :scrollable="true" left-icon="volume-o" v-if="addressMiss">
            您的地址信息尚未补全,为了更好的产品体验。诚邀您补全地址信息!
        </NoticeBar> -->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {NoticeBar} from 'vant';

    export default {
        watch: {
          $route (to, from) {
            var _hmt = _hmt || [];
            (function() {
              var hm = document.createElement("script");
              hm.src = "https://hm.baidu.com/hm.js?fcc1ecc3c16d7b7a64965e758505af9f";
              var s = document.getElementsByTagName("script")[0];
              s.parentNode.insertBefore(hm, s);
            })();
          }
        },
        computed: {
            ...mapState({
                showSpin: state => state.app.showSpin,
                custombgcolor: state => state.app.custombgcolor,
                addressMiss: state => state.user.userInfo.district_id === ''
            })
        },
        components: {
            NoticeBar
        },
        methods: {
            editInfo: function () {
                this.$router.push({name: "userEdit"})
            }
        },
        mounted() {
        }
    }
</script>
<style lang="less">
    @import "./App.less";
</style>
